import { recursive } from 'merge';

import { HostId } from 'src/app/core/host-identification/host-id.enum';

import { settings as customBackend } from './host-settings/custom.backend.settings';
import { settings as defaultSettings } from './host-settings/default.settings';
import { settings as devSettings } from './host-settings/dev.settings';
import { settings as expert } from './host-settings/expert.settings';
import { settings as intSettings } from './host-settings/int.settings';
import { settings as localSettings } from './host-settings/local.settings';
import { settings as prodSettings } from './host-settings/prod.settings';
import { settings as testSettings } from './host-settings/test.settings';
import { settings as timetravel } from './host-settings/timetravel.settings';
import type { Settings } from './settings.interface';

/**
 * Default settings are deep-merged with respective host settings to create a
 * map of host ids and settings.
 *
 * `SETTINGS` must contain only such values, that should not be lazy-loaded, as
 * they would otherwise block calls to external resources, which are stringently
 * required to render the initial app state.
 */
export const SETTINGS = new Map<HostId, Settings>();

for (const [environment, settings] of Object.entries({
  [HostId.Local]: localSettings,
  [HostId.Dev]: devSettings,
  [HostId.Test]: testSettings,
  [HostId.Int]: intSettings,
  [HostId.PreProd]: prodSettings, // intentionally prod settings for PRE PROD!
  [HostId.Prod]: prodSettings,
  [HostId.TimeTravel]: timetravel,
  [HostId.Expert]: expert,
  [HostId.CustomBackend]: customBackend,
  [HostId.UnitTestEnvironment]: testSettings,
  [HostId.Unknown]: prodSettings // in doubt, use prod settings
})) {
  SETTINGS.set(environment as HostId, recursive(true, defaultSettings, settings) as Settings);
}
